<template>
  <v-container fluid>
    <v-card width="100%" tile elevation="6" height="900px">
      <div id="contenedor">
        <v-layout row wrap="">
          <v-flex xs12 sm12 md12>
            <v-toolbar flat elevation="15" class="mt-9" height="80">
              <v-card class="icon" height="110" width="105">
                <v-icon
                  style="margin-left: 33px; margin-top: 29px"
                  color="white"
                  x-large=""
                  >mdi-account</v-icon
                >
              </v-card>
              <div class="usuario">USUARIOS</div>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="700px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn dark class="botonplus" v-on="on"
                    ><v-icon color="white">mdi-plus-thick</v-icon></v-btn
                  >
                </template>
                <v-card style="display: flex; flex-direction: column; max-height: 85vh;">
                  <v-card-title class="nav" style="flex-shrink: 0;">
                    <span class="headline" style="color: whitesmoke;">
                  <v-icon color="white">mdi-account</v-icon>
                  {{ formTitle }}
                </span>
                  </v-card-title>
                  <!-- componente del modal para agregar y actualizar -->
                  <v-card-text style="flex: 1 1 auto; overflow-y: auto; min-height: 0; max-height: 50vh;">
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            v-model="editedItem.cedula"
                            label="Cedula"
                            mask="#############"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            v-model="editedItem.nombre"
                            label="Nombre"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            v-model="editedItem.correo"
                            :rules="[rules.required, rules.email]"
                            label="Correo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            v-model="editedItem.celular"
                            label="Celular"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-autocomplete
                            persistent-hint
                            v-model="editedItem.idCargo"
                            label="Cargo"
                            :items="cargos"
                            item-value="idCargo"
                            item-text="opcion"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-autocomplete
                            v-model="editedItem.idEmpresa"
                            label="Empresa"
                            :items="empresas"
                            item-text="nombre"
                            item-value="idEmpresa"
                            :rules="[
                              (v) => !!v || 'Se requiere seleccionar una empresa',
                            ]"
                            required
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm12 md12 v-if="editedItem.idCargo != 18">
                          <v-autocomplete
                            v-model="editedItem.idZona"
                            label="Zona"
                            :items="zonas"
                            item-value="idZona"
                            :item-text="item => `${item.nombreZona} - ${item.nombreEmpresa || 'Sin Empresa'}`"
                            :rules="[
                              (v) => !!v || 'Se requiere seleccionar una zona',
                            ]"
                            required
                          >
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>{{ item.nombreZona }}</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span :style="{ color: item.idEmpresa == 1 ? '#1976d2' : item.idEmpresa == 2 ? '#d32f2f' : '#666' }">
                                    {{ item.nombreEmpresa || 'Sin Empresa' }}
                                  </span>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                            <template v-slot:selection="{ item }">
                              <span>{{ item.nombreZona }} - <strong>{{ item.nombreEmpresa || 'Sin Empresa' }}</strong></span>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-select
                            item-value="idRol"
                            item-text="rol"
                            :items="roles"
                            label="Rol"
                            v-model="editedItem.idRol"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-text-field
                            v-model="editedItem.contrasena"
                            label="Contraseña"
                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show ? 'text' : 'password'"
                            @click:append="show = !show"
                          ></v-text-field>
                        </v-flex>
                        <!--  -->
                        <v-checkbox
                          v-model="editedItem.vinculado"
                          label="vinculado"
                          :color="getcolor1()"
                          @click="getvalor()"
                          hide-details
                        ></v-checkbox>
                        <!--  -->
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                  <v-card-actions style="flex-shrink: 0; padding: 16px !important;">
                    <v-spacer></v-spacer>
                    <v-btn color="#1D3C7F" dark @click="close">Cancelar</v-btn>
                    <v-btn
                      color="#1D3C7F"
                      dark
                      @click="save"
                      :disabled="
                        !editedItem.cedula ||
                        !editedItem.nombre ||
                        !editedItem.contrasena ||
                        !editedItem.celular ||
                        !editedItem.idRol ||
                        !editedItem.idCargo ||
                        !editedItem.idEmpresa ||
                        (editedItem.idCargo && Number(editedItem.idCargo) !== 18 && !editedItem.idZona)
                      "
                      >Guardar</v-btn
                    >
                  </v-card-actions>
                  <!-- <pre>{{editedItem}}</pre>  -->
                </v-card>
              </v-dialog>
            </v-toolbar>
            <br />
            <div class="buscar">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar Usuario"
                single-line
                color="#294697"
              ></v-text-field>
            </div>
            <br />
            <v-data-table
              :headers="headers"
              :items="usuarios"
              :search="search"
              style="border: 1px solid #000"
              class="elevation-3"
            >
              <!-- tabla donde se pintan los datos obtenidos del arreglo -->
              <template v-slot:[`item.action`]="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon>

                <v-icon
                  v-if="item.estado == 1"
                  color="green"
                  medium
                  class="mr-2"
                  @click="inactivateItem(item, 0)"
                >
                  mdi-toggle-switch
                </v-icon>
                <v-icon
                  v-else
                  medium
                  class="mr-2"
                  color="red"
                  @click="activateItem(item, 1)"
                >
                  mdi-toggle-switch-off
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-alert :value="true" color="#294697" icon="mdi-alert" outlined
                  >No se encontro su busqueda</v-alert
                >
              </template>
            </v-data-table>
            <!-- alertas de las acciones que se hacen -->
            <v-snackbar
              v-model="snackbar"
              :bottom="y === 'bottom'"
              :left="x === 'left'"
              :multi-line="mode === 'multi-line'"
              :right="x === 'right'"
              :timeout="timeout"
              :top="y === 'top'"
              :vertical="mode === 'vertical'"
              color="#294697"
              style="color: white"
            >
              {{ text }}
              <v-btn color="#294697" depressed dark @click="snackbar = false"
                >Cerrar</v-btn
              >
            </v-snackbar>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import env from "../env";
import swal from "sweetalert";
export default {
  data() {
    return {
      ex4: ["p"],
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      /* fechaN:false,
      fechaI:false, */
      mode: "",
      estadoV: true,
      timeout: 6000,
      text: "",
      search: "",
      usuarios: [],
      areas: [],
      cargos: [],
      roles: [],
      zonas: [],
      empresas: [],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      dialog: false,
      headers: [
                {
          text: "Id",
          align: "left",
          value: "idUsuario",
          align: "center",
          class: "column",
        },
        {
          text: "Cedula",
          align: "left",
          value: "cedula",
          align: "center",
          class: "column",
        },
        {
          text: "Nombre",
          value: "nombre",
          align: "center",
          class: "column",
        },
        {
          text: "Cargo",
          value: "nombreCargo",
          align: "center",
          class: "column",
        },
        {
          text: "Empresa",
          value: "nombreEmpresa",
          align: "center",
          class: "column",
        },
        {
          text: "Editar",
          value: "action",
          sortable: false,
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        idUsuario: "",
        nombre: "",
        cedula: "",
        contrasena: "",
        idRol: "",
        correo: "",
        celular: "",
        idCargo: "",
        chat_id: "",
        idZona: "",
        idEmpresa: "",
        vinculado: "",
      },
      editedIndex: -1,
      editedItem: {
        idUsuario: "-",
        nombre: "",
        cedula: "",
        contrasena: "",
        idRol: "",
        correo: "",
        celular: "",
        idCargo: "",
        chat_id: "",
        idZona: "",
        idEmpresa: "",
        vinculado: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Editar Usuario";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerTodo();
    this.obtenerUsuarios();
    this.obtenerZonas();
    this.obtenerEmpresas();
  },

  methods: {
    // Metodo para obtener los usuarios
    obtenerUsuarios() {
      axios.get(`${env.endpoint}user/usuarios`).then((res) => {
        this.usuarios = res.data;
        console.log("usuarios", this.usuarios);
      });
    },
    /**
     * Metodo para obtener las zonas
     */
    obtenerZonas() {
      axios.get(`${env.endpoint}user/consultarZonas`).then((res) => {
        this.zonas = res.data;
        // console.log("", this.zonas);
      });
    },
    /**
     * Metodo para obtener las empresas
     */
    obtenerEmpresas() {
      axios.get(`${env.endpoint}user/empresas`).then((res) => {
        this.empresas = res.data;
        // console.log("empresas", this.empresas);
      });
    },
    /**
     * Metodo para obtener roles y areas
     */
    obtenerTodo() {
      axios.get(`${env.endpoint}user/cargos`).then((res) => {
        for (let index = 0; index < res.data.length; index++) {
          res.data[index].opcion =
            res.data[index].nombreCargo +
            " (" +
            res.data[index].cc_nombre_area +
            ")";
        }
        this.cargos = res.data;
      });
      axios
        .get(`${env.endpoint}user/rol`)
        .then((res) => (this.roles = res.data));
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.usuarios.indexOf(item);
      // console.log("el valor de editar es:", item)
      this.editedItem = Object.assign({}, item);
      //  console.log("el valor de  ", this.editedIndex)

      // console.log("el valor de editedItem", editedItem)
      this.dialog = true;
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    /**
     * Metodo para guardar y actualizar
     */
    save() {
      if (this.editedIndex > -1) {
        if (this.editedItem.contrasena.length >= 6) {
          var mayuscula = true;
          var minuscula = true;
          var numero = true;
          var caracter_raro = true;

          for (var i = 0; i < this.editedItem.contrasena.length; i++) {
            if (
              this.editedItem.contrasena.charCodeAt(i) >= 65 &&
              this.editedItem.contrasena.charCodeAt(i) <= 90
            ) {
              mayuscula = true;
            } else if (
              this.editedItem.contrasena.charCodeAt(i) >= 97 &&
              this.editedItem.contrasena.charCodeAt(i) <= 122
            ) {
              minuscula = true;
            } else if (
              this.editedItem.contrasena.charCodeAt(i) >= 48 &&
              this.editedItem.contrasena.charCodeAt(i) <= 57
            ) {
              numero = true;
            } else {
              caracter_raro = true;
            }
          }
          if (
            mayuscula == true &&
            minuscula == true &&
            caracter_raro == true &&
            numero == true
          ) {
            // stringify() convierte un objeto o valor de JavaScript en una cadena de texto JSON
            const usuario = JSON.stringify({
              idUsuario: this.editedItem.idUsuario,
              nombre: this.editedItem.nombre,
              cedula: this.editedItem.cedula,
              contrasena: this.editedItem.contrasena,
              idRol: this.editedItem.idRol,
              correo: this.editedItem.correo,
              celular: this.editedItem.celular,
              idCargo: this.editedItem.idCargo,
              chat_id: this.editedItem.chat_id,
              idZona: this.editedItem.idZona,
              idEmpresa: this.editedItem.idEmpresa,
              vinculado: this.editedItem.vinculado,
            });
            //  console.log("usuario:", usuario)
            // se seta los datos obtenidos del arreglo par modificarlo
            axios
              .get(`${env.endpoint}user/modificar_user?usuario=${usuario}`)
              .then((res) => {
                if (res.data.mensaje === "usuario actualizado") {
                  (this.snackbar = true),
                    (this.text = "usuario actualizado satisfactoriamente");
                } else if (res.data.mensaje === "error en la actualizacion") {
                  (this.snackbar = true),
                    (this.text = "Error en la actualización");
                }
              })
              .finally(() => {
                this.obtenerTodo();
                this.obtenerUsuarios();
              });
          } else {
            if (!mayuscula) {
              (this.snackbar = true), (this.text = "Minimo 1 mayúscula");
              this.editedItem.contrasena = "";
            } else {
              if (!minuscula) {
                (this.snackbar = true), (this.text = "Minimo 1 minúscula");
                this.editedItem.contrasena = "";
              } else {
                if (!caracter_raro) {
                  (this.snackbar = true),
                    (this.text = "Minimo 1 caracter especial");
                  this.editedItem.contrasena = "";
                } else {
                  (this.snackbar = true), (this.text = "Minimo 1 número");
                  this.editedItem.contrasena = "";
                }
              }
            }
          } // obtiene los datos del arreglo para poder actualizar el usuario en el modal
        } else {
          (this.snackbar = true), (this.text = "Minimo 8 caracteres");
          this.editedItem.contrasena = "";
        }
      } else {
        // obtiene los datos del arreglo para despues setearlos en una variable nuevoUsuario y pasarselo al metodo
        const nuevoUsuario = JSON.stringify({
          nombre: this.editedItem.nombre,
          cedula: this.editedItem.cedula,
          contrasena: this.editedItem.contrasena,
          idRol: this.editedItem.idRol,
          correo: this.editedItem.correo,
          celular: this.editedItem.celular,
          idCargo: this.editedItem.idCargo,
          chat_id: this.editedItem.chat_id,
          idZona: this.editedItem.idZona,
          idEmpresa: this.editedItem.idEmpresa,
          vinculado: this.editedItem.vinculado,
        });
        //  console.log("nuevoUsuario:", nuevoUsuario)
        // se crea el usuario
        axios
          .get(`${env.endpoint}user/create_user?usuario=${nuevoUsuario}`)
          .then((res) => {
            if (
              (res.data.mensaje === "usuario registrado",
              console.log("la data es ", this.data))
            ) {
              (this.snackbar = true),
                (this.text = "Usuario registrado satisfactoriamente");
            } else if (res.data.mensaje === "error en el registro") {
              (this.snackbar = true), (this.text = "Error al registrar");
            } else if (res.data.mensaje === "error usuario existe") {
              (this.snackbar = true),
                (this.text = "El usuario ya existe en la plataforma");
            }
            // console.log(nuevoUsuario);
          });
        this.obtenerUsuarios(), this.obtenerTodo();
      }
      this.close();
    },
    getvalor() {
      // console.log("this.editedItem.vinculado",this.editedItem.vinculado)
      let valor;
      if (this.editedItem.vinculado == true) {
        this.editedItem.vinculado = valor = "1";
        console.log(valor);
      } else if (this.editedItem.vinculado == false) {
        this.editedItem.vinculado = valor = "0";
        console.log(valor);
      }
      // console.log("persona:",this.editedIndex)
      // this.editedItem.vinculado == 0
    },
    actualizarVinculo() {},

    getcolor1() {
      //   console.log("el valor de editedIndex:",this.editedIndex)
      if (this.editedItem.vinculado == 1) return "primary";
      if (this.editedItem.vinculado == 0) return "FFFFFF";
    },
    activateItem(item, estado) {
      const data = JSON.stringify({
        idUsuario: item.idUsuario,
        estado,
      });
      // console.log(item);
      swal({
        title: "Este usuario se activara del sistema.",
        text: "¿Estas seguro de activar al usuario?",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}user/estado_user?usuario=${data}`)
            .then((res) => {
              swal("Usuario inactivado con exito!", {
                icon: "success",
              });
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              this.obtenerUsuarios();
            });
        } else {
          swal("Proceso de activacion cancelado");
        }
      });
    },
    inactivateItem(item, estado) {
      const data = JSON.stringify({
        idUsuario: item.idUsuario,
        estado,
      });
      // console.log(item);
      swal({
        title: "Este usuario se inactivara del sistema.",
        text: "¿Estas seguro de inactivar al usuario?",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}user/estado_user?usuario=${data}`)
            .then((res) => {
              swal("Usuario inactivado con exito!", {
                icon: "success",
              });
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            })
            .finally(() => {
              this.obtenerUsuarios();
            });
        } else {
          swal("Proceso de inactivacion cancelado");
        }
      });
    },
  },
};
</script>

<style scoped>
.contenedor {
  position: relative;
  top: 100px;
}

.buscar {
  width: 400px;
  max-width: 100%;
  margin-left: 15px;
}
.usuario {
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 22px;
}
</style>
